'use strict';

intellidealerAppEquipmentModule.config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state(
    'navigation.equipment.equipmentForSale.equipmentForSaleDetails.transmission', {
      url: '/transmission',
      templateUrl: 'app/scripts/modules/equipment/views/transmission.html'
    }
  );

  $stateProvider.state(
    'public.equipment.equipmentForSale.equipmentForSaleDetails.transmission', {
      url: '/transmission',
      templateUrl: 'app/scripts/modules/equipment/views/transmission.html'
    }
  );
}]);
